import { Component, OnInit } from '@angular/core';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { AssetsManagementService } from '../../services/assets-management.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';

@Component({
  selector: 'app-assets-popup-confirmation-report',
  templateUrl: './assets-popup-confirmation-report.component.html',
  styleUrls: ['./assets-popup-confirmation-report.component.css']
})
export class AssetsPopupConfirmationReportComponent implements OnInit {
  financialYearList;
  branchList;
  selectedFinancialYear;
  selectedBranch;
  confirmDateList;
  selectedDate;
  reportList = [];
  userRole;
  accessResponse: any;

  constructor(private masterDataService: MasterDataService,
    private assetsManagementService: AssetsManagementService,
    private commonMessageService: CommonMessageService,
    private branchFilterService: BranchFilterService
  ) { }

  ngOnInit(): void {
    this.selectedFinancialYear = "";
    this.selectedBranch = "";
    this.selectedDate = "";
    this.loadInitDetails();
  }
  loadInitDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialYearList = res;
    });

    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchList = res;
    // });
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });

  }

  onBranchSelect() {
    this.selectedDate = '';
  }

  onYearSelect() {
    this.selectedBranch = '';
    this.selectedDate = '';
    if (this.selectedFinancialYear != undefined && this.selectedFinancialYear != '') {
      this.assetsManagementService.getAssetConfirmationDate(this.selectedFinancialYear.id).subscribe((resp: any) => {
        console.log('date details', resp);
        this.confirmDateList = resp;
      })
    }
  }

  showExcelButton: Boolean;
  onViewReport() {
    console.log('inside view report');
    if (this.selectedFinancialYear == undefined || this.selectedFinancialYear == null || this.selectedFinancialYear == '' ||
      this.selectedBranch == undefined || this.selectedBranch == null || this.selectedBranch == '' ||
      this.selectedDate == undefined || this.selectedDate == null || this.selectedDate == '') {
      this.commonMessageService.swalAlertWithoutIcon('', "Please select all fields.");
    } else {
      this.assetsManagementService.getMonthlyConfirmDetailReport(this.selectedFinancialYear.id, this.selectedDate, this.selectedBranch.id).subscribe((resp: any) => {
        console.log('monthly confirm report details', resp);
        if (resp.length > 0) {
          this.reportList = resp;
          this.showExcelButton = true;
        } else {
          this.commonMessageService.swalAlertWithoutIcon('', "No Record Found.");
          this.showExcelButton = false;
          this.reportList = [];
        }
      })
    }
  }

  onExportToExcelReport() {
    this.assetsManagementService.getMonthlyConfirmDetailReportExcel(this.selectedFinancialYear.id, this.selectedDate, this.selectedBranch.id).subscribe((resp: any) => {
      console.log('monthly confirm report details', resp);
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "PopupConfirmationReport.xlsx";
      link.click();
    })
  }
}
